import { render, staticRenderFns } from "./AdminVodStats.vue?vue&type=template&id=a0978e0c&scoped=true"
import script from "./AdminVodStats.vue?vue&type=script&lang=js"
export * from "./AdminVodStats.vue?vue&type=script&lang=js"
import style0 from "./AdminVodStats.vue?vue&type=style&index=0&id=a0978e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0978e0c",
  null
  
)

export default component.exports